import React, { memo, useEffect, useCallback, useMemo } from "react";
import "./index.scss";
import { useHistory, useLocation } from "react-router-dom";
import { setScreenSaverStatusAction } from "../../store/control/actions";
import { useDispatch, useSelector } from "react-redux";
import { useRPC } from "../../hooks/rpc";
import { onClickHandler } from "../../utils/onclick";
import { setPasswordAction } from "../../store/control/actions";
import { useDateTime } from "../../hooks/date-time";
import { useLocalization } from "../../hooks/localization";
import { getFormattedMonthNameForWebsocket } from "../../utils/format";

let timerWithDigitalClock;
export const DigitalClock = memo(function DigitalClock() {
  const history = useHistory();
  const {t} = useLocalization()
  const dispatch = useDispatch();
  const {date: newDate, day, time: newTime} = useDateTime()
  const passStatus = useSelector((state) => state.control.passwordStatus);
  const [rpc] = useRPC();
  const location = useLocation();

  const customDate = useMemo(() => {
      const dateObject = newDate.split(".")
      let customizedDay: number;
      if (dateObject?.[1].startsWith('0')) {
        customizedDay = Number(dateObject?.[1])
      }
      return {day: dateObject?.[0], month: customizedDay, year: dateObject?.[2]}
  }, [newDate])



  useEffect(() => {
    timerWithDigitalClock = setInterval(() => {
      history.push("/digital-clock");
    }, 60000);
    return () => {
      clearInterval(timerWithDigitalClock);
    };
  }, [history, dispatch]);

  const hideDigital = useCallback(() => {
    clearInterval(timerWithDigitalClock);
    dispatch(setScreenSaverStatusAction(null));

    if (passStatus === false && !location.pathname.includes('/pin-login')) {
      history.push("/lock");
      dispatch(setPasswordAction(null));
    } else {
      history.push("/");
    }

    rpc.touchEvent().then();
  }, [history, passStatus, dispatch, rpc, location.pathname]);


  return (
    <div className="container-clock" {...onClickHandler(hideDigital)}>
      <div id="digital-div1">
        <p id="digital-time">{newTime}</p>
        <p id="digital-date">{customDate?.day} {t(getFormattedMonthNameForWebsocket(customDate?.month - 1))} {customDate?.year} {t(day)}</p>
        <div id="digital-text"></div>
      </div>
    </div>
  );
});
